export const environment = {
  production: false,
  apiUrl: 'https://api.reconcilex.petkovlabs.com/reconcilex/api/v1',
};
